import { Edit, ShieldUser, Trash, User } from 'lucide-react';
import { ColumnDef, Row, Table } from '@tanstack/react-table';
import { Member } from '@/types';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';

interface TableMeta {
  onEditRow?: (member: Member) => void;
  onDeleteRow?: (member: Member) => void;
}

export const columns: (isOwner: boolean) => ColumnDef<Member, unknown>[] = (
  isOwner: boolean,
) => [
  {
    id: 'avatar',
    header: '',
    meta: {
      className: 'w-[1%]',
    },
    cell: () => (
      <div className='flex items-center justify-center px-1'>
        <div className='size-8 bg-muted rounded-full p-2 flex items-center justify-center flex-grow-0'>
          <User className='size-4' />
        </div>
      </div>
    ),
  },
  {
    accessorKey: 'email',
    header: 'Email',
    cell: ({ row }: { row: Row<Member> }) => (
      <span className='text-muted-foreground'>{row.original.email}</span>
    ),
  },
  {
    accessorKey: 'role',
    header: 'Role',
    cell: ({ row }: { row: Row<Member> }) => (
      <span className='inline-flex items-center gap-1.5 capitalize'>
        {row.original.role}
        {row.original.is_infra_admin && (
          <Tooltip>
            <TooltipTrigger asChild>
              <ShieldUser
                className='size-4 text-green-600 dark:text-green-500'
                aria-label='Infra Admin'
              />
            </TooltipTrigger>
            <TooltipContent>Infra Admin</TooltipContent>
          </Tooltip>
        )}
      </span>
    ),
  },
  ...(isOwner
    ? [
        {
          id: 'actions',
          header: '',
          cell: ({
            row,
            table,
          }: {
            row: Row<Member>;
            table: Table<Member>;
          }) => (
            <div className='flex justify-end gap-1'>
              <Button
                variant='ghost'
                size='icon'
                onClick={() =>
                  (table.options.meta as TableMeta)?.onEditRow?.(row.original)
                }
              >
                <Edit />
              </Button>
              <Button
                variant='ghost'
                size='icon'
                onClick={() =>
                  (table.options.meta as TableMeta)?.onDeleteRow?.(row.original)
                }
              >
                <Trash />
              </Button>
            </div>
          ),
        },
      ]
    : []),
];
